import { render, staticRenderFns } from "./Shipper.vue?vue&type=template&id=45fc59e1&"
import script from "./Shipper.vue?vue&type=script&lang=js&"
export * from "./Shipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../var/www/transport-app/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports